var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('v-container',{attrs:{"fill-height":""}},[_c('v-row',{attrs:{"align":"center"}},[_c('v-col',[_c('v-card',[_c('v-card-title',[_vm._v(" Registration Landing ")]),_c('v-card-text',[_vm._v(" "+_vm._s(JSON.stringify(_vm.user))+" ")])],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }